<template>
    <div>
        <base-crud
                crudName="Banners"
                newText="Novo Banner"
                :table="highlightTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="true"
                :enableEdit="true"
                :enableDelete="true"
                :enableView="true"
                :enableSetStatus="true"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                highlightTable: 'highlightTable',
                users: [],
                pages: [],
                url: '',
                columns: ['id', 'title', 'photo', 'status', 'actions'],
                tableData: ['id', 'title', 'photo', 'status'],
                options: {
                    sortable: ['id', 'title'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll' },
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                        'title': 'Título',
                        'photo': 'Foto',
                        'actions': 'Ações'
                    },
                    templates: {
                        status: function (h, row, index) {
                            return row.status === 'ina' ? 'Inativo' : 'Ativo'
                        }
                    }
                },
                endPoint: 'highlight/?showAll=true/'
            }
        },
        components: {
            BaseCrud
        }
    }
</script>

<style scoped>
    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Highlight/Crud.vue